exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table__category {\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-align: center;\n  padding: .25rem;\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/markets/components/market-detail/market-detail.component.scss
// module id = 973
// module chunks = 1